// @deprecated, use @enums/event.ts
export const OFFER_EVENT = {
  // Received when a slider have to appear
  SLIDER_SHOW: 'slider-show',
  // Received after deleting a favorite
  FAVORITE_REMOVE_LOADER: 'favorite-remove-loader',
  // Received after send refused match proposal form
  FAVORITE_OFFER_REMOVE: 'favorite-offer-remove',
};
